import { GraphQLCameraAssociationRequester } from '@cobliteam/api-lib';

import type { AssociationConfig } from '@cobliteam/common-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const QUERY_KEY = 'CAMERA-ASSOCIATION';

const useCameraAssociation = () => {
  const queryClient = useQueryClient();

  const getCameraAssociation = () => {
    const cameraAssociationGraphQLRequester = new GraphQLCameraAssociationRequester();

    return useQuery({
      queryKey: [QUERY_KEY],
      queryFn: () => cameraAssociationGraphQLRequester.getCameraAssociation(),
      retry: false,
      enabled: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 300000,
    });
  };

  const updateCameraAssociation = useMutation<boolean, unknown, { updateCameraAssociation: AssociationConfig }>({
    mutationFn: (request) => {
      const cameraAssociationGraphQLRequester = new GraphQLCameraAssociationRequester();
      return cameraAssociationGraphQLRequester.updateCameraAssociation(request.updateCameraAssociation);
    },
    onMutate: async (variables) => {
      const previousValue = queryClient.getQueriesData({
        queryKey: [QUERY_KEY],
      });
      queryClient.setQueryData([QUERY_KEY], {
        ...previousValue,
        ...variables.updateCameraAssociation,
      });
      return { previousValue };
    },
  });

  return {
    getCameraAssociation,
    updateCameraAssociation,
  };
};

export default useCameraAssociation;
